import React from "react"
import { Box, Typography } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import { Check, Close } from "@material-ui/icons"
import { useClasses, joinClasses } from "../globals"

export const passwordConditions = [
  {
    title: "8-24 characters long",
    condition: pass => pass.length >= 8 && pass.length <= 24
  },
  {
    title: "Lower case letter (a-z)",
    condition: pass => /[a-z]/.test(pass)
  },
  {
    title: "Upper case letter (A-Z)",
    condition: pass => /[A-Z]/.test(pass)
  },
  {
    title: "Number (0-9)",
    condition: pass => /[0-9]/.test(pass)
  },
  {
    title: "Special symbol ($@$!%*?&)",
    condition: pass => /[$@$!%*?&]/.test(pass)
  }
]

export const isPasswordValid = (pass, conditions=passwordConditions) => {
  return conditions.every(item => item.condition(pass));
}
/**
 * Password strength hint
 *
 * Shows an Alert box with the list of criterias
 * and success/fail icons next to each of the criteria
 *
 * @param {object} props
 * @param {string} props.password Password to check the strength against
 * @param {string} props.message Leading text
 * @param {{title: string, condition: function}[]} props.conditions Array of conditions
 */
export const PasswordHint = ({
  password = "",
  message = "Password must have",
  conditions = passwordConditions
}) => {
  const classes = useClasses()

  return (
    // Color Alert success if all the conditions are true
    <Alert
      severity={
        conditions.filter(item => item.condition(password)).length ===
          conditions.length
          ? "success"
          : "error"
      }
    >
      {/* Leading text */}
      <Typography>{message}</Typography>

      {/* Conditions */}
      {conditions.map((item, index) => (
        <Box
          key={index}
          className={joinClasses(classes._Flex, classes._AlignItemsCenter)}
        >
          <Box
            className={joinClasses(
              classes._FlexGrow0,
              classes._Flex,
              classes._AlignItemsCenter,
              classes._MarginRightHalf
            )}
          >
            {item.condition(password) ? (
              <Check fontSize="small" className={classes._FontColorSuccess} />
            ) : (
              <Close fontSize="small" className={classes._FontColorError} />
            )}
          </Box>
          <Box className={classes._FlexGrow1}>
            <Typography>{item.title}</Typography>
          </Box>
        </Box>
      ))}
    </Alert>
  )
}
